<div class="welcome-container mt-4 text-center">
  <h2 class="display-5">¡Bienvenido, {{ sesion.nombre + (sesion.apellidoPaterno ? ' ' + sesion.apellidoPaterno : '') + (sesion.apellidoMaterno ? ' ' + sesion.apellidoMaterno : '') }} !</h2>
  <p class="lead">{{ fechaHoy | titlecase }}.</p>
  <p>Gestionando tus actividades en <strong>SAPI</strong>.</p>
  <img src="assets/img/sapi.png" alt="SAPI Logo" class="img-fluid mt-3" style="max-height: 50px;" />
</div>
